export function pluralWord(n: number, one: string, few: string, many: string): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return few;
  return many;
}

export function pluralSeats(n: number): string {
  return `${n} ${pluralWord(n, "место", "места", "мест")}`;
}

export function pluralParticipants(n: number): string {
  return `${n} ${pluralWord(n, "участник", "участника", "участников")}`;
}

export function pluralCities(n: number): string {
  return `${n} ${pluralCityLabel(n)}`;
}
export function pluralRequests(n: number): string {
  return `${n} ${pluralWord(n, "запрос", "запроса", "запросов")}`;
}

export function pluralCoffeeMeetingLabel(n: number): string {
  return pluralWord(n, "встреча на кофе", "встречи на кофе", "встреч на кофе");
}

export function pluralHeldMeetingLabel(n: number): string {
  return pluralWord(n, "встреча проведена", "встречи проведено", "встреч проведено");
}

export function pluralPeopleCameLabel(n: number): string {
  return pluralWord(n, "человек пришёл", "человека пришло", "человек пришло");
}

export function pluralVisitedMeetingLabel(n: number): string {
  return pluralWord(n, "встреча посещена", "встречи посещено", "встреч посещено");
}

export function pluralHostedCircleLabel(n: number): string {
  return pluralWord(n, "сообщество веду", "сообщества веду", "сообществ веду");
}

export function pluralCityLabel(n: number): string {
  return pluralWord(n, "город", "города", "городов");
}

export function pluralEvents(n: number): string {
  return `${n} ${pluralWord(n, "мероприятие", "мероприятия", "мероприятий")}`;
}

export function pluralInvited(n: number): string {
  return `${n} ${pluralWord(n, "приглашённый", "приглашённых", "приглашённых")}`;
}

export function pluralCircles(n: number): string {
  return `${n} ${pluralWord(n, "сообщество", "сообщества", "сообществ")}`;
}

export function pluralMeetings(n: number): string {
  return `${n} ${pluralWord(n, "встреча", "встречи", "встреч")}`;
}
